(function(){
var RM=matchMedia('(prefers-reduced-motion: reduce)').matches;
function p2(n){return n<10?'0'+n:''+n}

/* crosshair */
(function(){var c=document.querySelector('.xh');if(!c||RM)return;var x=0,y=0,tx=0,ty=0;
 addEventListener('mousemove',function(e){tx=e.clientX;ty=e.clientY},{passive:true});
 (function l(){x+=(tx-x)*.3;y+=(ty-y)*.3;c.style.transform='translate('+x+'px,'+y+'px) translate(-50%,-50%)';
  requestAnimationFrame(l)})()})();

/* ── stock lifeline ──────────────────────────────────────────────────────
   The bar is measured against a FIXED ceiling, never against the size of the
   run, so it cannot be read backwards into "how many did they actually sell".
   Only the absolute remaining count is ever printed. Keep CEIL in step with
   snippets/triangle-life.liquid.                                            */
var LIFE_CEIL=15;
function lifeState(q){
 q=Math.max(parseInt(q,10)||0,0);
 /* floor, to match Liquid's integer divided_by exactly — otherwise the bar
    nudges by a fraction of a percent the moment you click a size. */
 var pct=Math.floor(Math.min(q,LIFE_CEIL)*100/LIFE_CEIL);
 if(q===0)   return {st:'out', n:'SOLD OUT',        s:'GONE',          pct:0};
 if(q===1)   return {st:'crit',n:'ONLY 1 LEFT',     s:'LAST ONE',      pct:pct};
 if(q<=3)    return {st:'crit',n:'ONLY '+q+' LEFT', s:'FINAL PIECES',  pct:pct};
 if(q<=8)    return {st:'low', n:'ONLY '+q+' LEFT', s:'RUNNING LOW',   pct:pct};
 return           {st:'ok',  n:q+' LEFT',         s:'IN STOCK',      pct:pct};
}
function paintLife(el,q){
 if(!el)return;
 var v=lifeState(q);
 el.classList.remove('ok','low','crit','out');el.classList.add(v.st);
 var n=el.querySelector('[data-life-n]'),s=el.querySelector('[data-life-s]'),
     b=el.querySelector('[data-life-bar]');
 if(n)n.textContent=v.n; if(s)s.textContent=v.s;
 if(b){b.style.width=v.pct+'%';
  if(!RM){el.classList.remove('pulse');void el.offsetWidth;el.classList.add('pulse')}}
}
window.paintLife=paintLife;

function start(){
 /* make a missing asset obvious instead of invisible */
 document.querySelectorAll('img').forEach(function(im){
  im.addEventListener('error',function(){im.classList.add('miss');
   im.setAttribute('data-missing',im.getAttribute('src')||'');
   console.error('TRIANGLE: image failed to load —',im.getAttribute('src'));});
  if(im.complete&&im.naturalWidth===0)im.classList.add('miss');
 });

 /* hero letters */
 var h1=document.querySelector('.hero h1');
 if(h1&&!h1.dataset.done){h1.dataset.done='1';
  var t=h1.textContent;h1.textContent='';
  t.split('').forEach(function(ch,i){var s=document.createElement('span');s.className='ch';
   s.textContent=ch;s.style.transitionDelay=(i*.045)+'s';h1.appendChild(s)});
  requestAnimationFrame(function(){h1.classList.add('go')});
  if(!RM)setInterval(function(){h1.classList.add('gl');
   setTimeout(function(){h1.classList.remove('gl')},240)},4200)}

 /* reveal + wipe */
 var io=new IntersectionObserver(function(e){e.forEach(function(x){
  if(x.isIntersecting){x.target.classList.add('in');io.unobserve(x.target)}})},
  {threshold:.1,rootMargin:'0px 0px -6% 0px'});
 document.querySelectorAll('.rv').forEach(function(el){io.observe(el)});

 /* stagger display type */
 document.querySelectorAll('[data-stagger]').forEach(function(el){
  if(el.dataset.done)return;el.dataset.done='1';
  var t=el.textContent;el.textContent='';
  t.split('').forEach(function(ch,i){var s=document.createElement('span');
   s.textContent=ch===' '?' ':ch;s.style.display='inline-block';s.style.opacity='0';
   s.style.transform='translateY(65%)';
   s.style.transition='opacity .5s var(--e) '+(i*.032)+'s,transform .55s var(--e) '+(i*.032)+'s';
   el.appendChild(s)})});
 var so=new IntersectionObserver(function(e){e.forEach(function(x){
  if(!x.isIntersecting)return;so.unobserve(x.target);
  x.target.querySelectorAll('span').forEach(function(s){s.style.opacity='1';s.style.transform='none'})})},{threshold:.25});
 document.querySelectorAll('[data-stagger]').forEach(function(el){so.observe(el)});

 /* count-up */
 var co=new IntersectionObserver(function(e){e.forEach(function(x){
  if(!x.isIntersecting)return;co.unobserve(x.target);
  var el=x.target,to=parseInt(el.dataset.count,10),n=0;
  if(RM){el.textContent=to;return}
  var st=performance.now(),dur=1100;
  (function f(now){var p=Math.min((now-st)/dur,1);
   el.textContent=Math.round(to*(1-Math.pow(1-p,3)));
   if(p<1)requestAnimationFrame(f)})(st)})},{threshold:.5});
 document.querySelectorAll('[data-count]').forEach(function(el){co.observe(el)});

 /* tilt */
 /* cursor tilt removed — the artwork holds still. Scroll parallax still runs. */

 /* magnetic buttons */
 if(!RM)document.querySelectorAll('.cta,.atc,.bar-t .go').forEach(function(b){
  b.addEventListener('mousemove',function(e){var r=b.getBoundingClientRect();
   b.style.transform='translate('+((e.clientX-r.left-r.width/2)*.16).toFixed(1)+'px,'+
    ((e.clientY-r.top-r.height/2)*.22).toFixed(1)+'px)'},{passive:true});
  b.addEventListener('mouseleave',function(){b.style.transform=''})});

 /* parallax + colour field + marquee velocity */
 var pars=[].slice.call(document.querySelectorAll('[data-par]'));
 var field=document.querySelector('.field'),secs=[].slice.call(document.querySelectorAll('[data-ink]'));
 var mqs=[].slice.call(document.querySelectorAll('.mq-t'));
 var last=0,tick=false;
 function fr(){tick=false;
  var y=pageYOffset||document.documentElement.scrollTop;
  if(!RM){
   pars.forEach(function(el){var r=el.getBoundingClientRect();
    if(r.bottom<-200||r.top>innerHeight+200)return;
    var mid=r.top+r.height/2-innerHeight/2;
    el.style.transform='translate3d(0,'+(mid*parseFloat(el.dataset.par)).toFixed(1)+'px,0)'});
   var v=Math.min(Math.abs(y-last)/9,4);last=y;
   mqs.forEach(function(m){m.style.animationDuration=(24/(1+v*.5)).toFixed(2)+'s'});
   if(field){var cur=null;
    secs.forEach(function(s){var r=s.getBoundingClientRect();
     if(r.top<innerHeight*.55&&r.bottom>innerHeight*.35)cur=s.dataset.ink});
    field.style.background=cur?'radial-gradient(ellipse at 50% 40%,'+cur+'1f,transparent 62%)':'none'}
  }}
 addEventListener('scroll',function(){if(!tick){tick=true;requestAnimationFrame(fr)}},{passive:true});
 fr();

 /* act status — OPEN / LOW / CLOSED. No numbers shown anywhere. */
 var LBL={OPEN:'OPEN',LOW:'RUNNING LOW',CLOSED:'CLOSED'};
 var status={I:'OPEN',II:'OPEN',III:'OPEN'};
 function paint(){document.querySelectorAll('[data-status]').forEach(function(el){
   var st=status[el.dataset.status]||'OPEN';
   var t=el.querySelector('.txt2');if(t)t.textContent=LBL[st]||st;
   el.classList.toggle('closed',st==='CLOSED')})}
 paint();window.setActStatus=function(o){status=o;paint()};


 /* tutorial */
 (function(){
  var rail=document.querySelectorAll('.tut .rail button'),
      panels=document.querySelectorAll('.tut .panel'),
      dots=document.querySelectorAll('.tut .dots2 i');
  if(!rail.length)return;
  var i=0,timer=null,auto=true;
  function show(n){
   i=n;
   rail.forEach(function(b,k){b.classList.toggle('on',k===n);b.classList.remove('run');
    if(k===n&&auto&&!RM){void b.offsetWidth;b.classList.add('run')}});
   panels.forEach(function(p,k){p.classList.toggle('on',k===n)});
   dots.forEach(function(d,k){d.classList.toggle('on',k===n)});
  }
  function next(){show((i+1)%rail.length)}
  function play(){if(RM)return;clearInterval(timer);timer=setInterval(next,5200)}
  rail.forEach(function(b,k){b.addEventListener('click',function(){
   auto=false;clearInterval(timer);show(k);
   rail.forEach(function(x){x.classList.remove('run')})})});
  show(0);
  var to=new IntersectionObserver(function(e){e.forEach(function(x){
   if(x.isIntersecting&&auto)play();else clearInterval(timer)})},{threshold:.35});
  to.observe(document.querySelector('.tut'));
 })();

 /* gallery */
 document.querySelectorAll('[data-gal]').forEach(function(g){
  var main=g.querySelector('.plate img');
  g.querySelectorAll('.thumbs button').forEach(function(b){
   b.addEventListener('click',function(){
    g.querySelectorAll('.thumbs button').forEach(function(x){x.classList.remove('on')});
    b.classList.add('on');main.style.opacity='0';
    setTimeout(function(){main.src=b.dataset.full;main.alt=b.dataset.alt||'';main.style.opacity='1'},160)})})});

 /* size + atc */
 var chosen=null;
 document.querySelectorAll('.sizes button').forEach(function(b){
  b.addEventListener('click',function(){
   document.querySelectorAll('.sizes button').forEach(function(x){x.classList.remove('on')});
   b.classList.add('on');chosen=b.dataset.size;
   if(b.hasAttribute('data-stock'))paintLife(document.querySelector('[data-life]'),b.getAttribute('data-stock'));
   var n=document.querySelector('.snote');if(n){n.textContent='SIZE '+chosen+' SELECTED';n.classList.remove('err')}})});
 var a=document.querySelector('.atc');
 if(a)a.addEventListener('click',function(){
  var n=document.querySelector('.snote');
  if(!chosen){if(n){n.textContent='PICK A SIZE FIRST';n.classList.add('err')}return}
  a.classList.add('done');var o=a.textContent;a.textContent='RECEIVED ✓';
  setTimeout(function(){a.classList.remove('done');a.textContent=o},2000)});
}

/* boot */
(function(){var b=document.getElementById('boot');if(!b){start();return}
 var big=b.querySelector('.big'),bar=b.querySelector('.bar i'),st=b.querySelector('.st');
 function done(){if(b.classList.contains('done'))return;b.classList.add('done');
  document.body.classList.remove('lock');
  setTimeout(function(){b.parentNode&&b.parentNode.removeChild(b)},1000);start()}
 if(RM){done();return}
 var n=0,msg=['ESTABLISHING UPLINK','LOCATION //PLANET EARTH','OBJECTIVE //WE ARE ONE','FIRST CONTACT //OPEN'];
 var id=setInterval(function(){n+=Math.random()*11+4;
  if(n>=100){n=100;clearInterval(id);big.textContent='100';big.setAttribute('data-v','100');
   bar.style.width='100%';st.textContent=msg[3];b.classList.add('hit');setTimeout(done,780);return}
  var s=p2(Math.floor(n));big.textContent=s;big.setAttribute('data-v',s);
  bar.style.width=n+'%';st.textContent=msg[Math.min(Math.floor(n/34),2)]},110);
 setTimeout(done,6500)})();
})();


/* ══ TRIANGLE — Shopify AJAX cart ══════════════════════════════════
   Multiple products, multiple sizes, multiple quantities.
   Nothing leaves the page until checkout.                          */
(function(){
  var money=function(c){ /* cents -> LKR string; overridden by Shopify format if present */
    try{return (window.Shopify&&Shopify.formatMoney)?Shopify.formatMoney(c,window.TRI_MONEY||'LKR {{amount}}')
      :'LKR '+(c/100).toLocaleString(undefined,{minimumFractionDigits:0,maximumFractionDigits:0});}
    catch(e){return 'LKR '+(c/100).toFixed(0);}
  };
  var scrim,drawer,itemsEl,subEl,btns=[],busy=false;

  function q(s,r){return (r||document).querySelector(s);}
  function qa(s,r){return [].slice.call((r||document).querySelectorAll(s));}

  function open(){ if(scrim){scrim.classList.add('on');drawer.classList.add('on');
    document.body.style.overflow='hidden';} }
  function close(){ if(scrim){scrim.classList.remove('on');drawer.classList.remove('on');
    document.body.style.overflow='';} }

  function render(cart){
    if(!itemsEl)return;
    qa('[data-cart-count]').forEach(function(el){
      el.textContent=cart.item_count;
      el.closest('.tri-cartbtn')&&el.closest('.tri-cartbtn').classList.add('bump');
      setTimeout(function(){el.closest('.tri-cartbtn')&&el.closest('.tri-cartbtn').classList.remove('bump');},520);
    });
    if(!cart.items.length){
      itemsEl.innerHTML='<div class="tri-empty">Nothing claimed yet.</div>';
      if(subEl)subEl.textContent=money(0);
      var ft=q('.tri-ft'); if(ft)ft.style.display='none';
      return;
    }
    var ft=q('.tri-ft'); if(ft)ft.style.display='';
    itemsEl.innerHTML=cart.items.map(function(it,i){
      var img=it.image?it.image.replace(/(\.[a-z]+)(\?|$)/i,'_160x$1$2'):'';
      return '<div class="tri-li" data-key="'+it.key+'">'+
        (img?'<img src="'+img+'" alt="">':'<div></div>')+
        '<div><div class="t">'+it.product_title+'</div>'+
        '<div class="v m">'+(it.variant_title||'')+'</div>'+
        '<div class="tri-qty"><button type="button" data-ch="-1" aria-label="Decrease">&minus;</button>'+
        '<span>'+it.quantity+'</span>'+
        '<button type="button" data-ch="1" aria-label="Increase">+</button></div>'+
        '<a class="tri-rm m" data-rm>REMOVE</a></div>'+
        '<div class="pz">'+money(it.line_price)+'</div></div>';
    }).join('');
    if(subEl)subEl.textContent=money(cart.total_price);
  }

  function get(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}})
    .then(function(r){return r.json();}).then(render); }

  function change(key,qty){
    if(busy)return; busy=true; drawer&&drawer.classList.add('busy');
    return fetch('/cart/change.js',{method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json();}).then(render)
      .catch(function(e){console.error('TRIANGLE cart:',e);})
      .then(function(){busy=false;drawer&&drawer.classList.remove('busy');});
  }

  function boot(){
    scrim=q('[data-tri-scrim]'); drawer=q('[data-tri-drawer]');
    itemsEl=q('[data-tri-items]'); subEl=q('[data-tri-sub]');
    if(scrim)scrim.addEventListener('click',close);
    qa('[data-tri-close]').forEach(function(b){b.addEventListener('click',close);});
    qa('[data-tri-open]').forEach(function(b){b.addEventListener('click',function(e){
      e.preventDefault();open();get();});});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});

    if(itemsEl)itemsEl.addEventListener('click',function(e){
      var li=e.target.closest('.tri-li'); if(!li)return;
      var key=li.dataset.key, cur=parseInt(li.querySelector('.tri-qty span').textContent,10);
      if(e.target.closest('[data-rm]')) return change(key,0);
      var ch=e.target.closest('[data-ch]'); if(!ch)return;
      change(key,Math.max(cur+parseInt(ch.dataset.ch,10),0));
    });

    /* ── product form ── */
    qa('[data-tri-form]').forEach(function(form){
      var hid=q('[data-variant-id]',form), qty=q('[data-qty]',form),
          atc=q('.atc',form), note=q('.snote'), chosen=null;

      qa('.sizes button',form).forEach(function(b){
        b.addEventListener('click',function(){
          if(b.disabled)return;
          qa('.sizes button',form).forEach(function(x){x.classList.remove('on');});
          b.classList.add('on'); chosen=b.dataset.vid; hid.value=chosen;
          paintLife(q('[data-life]'),b.getAttribute('data-stock'));
          if(note){note.textContent='SIZE '+b.textContent.trim()+' SELECTED';note.classList.remove('err');}
          if(atc){atc.disabled=false;}
        });
        if(b.classList.contains('on')&&!b.disabled){chosen=b.dataset.vid;hid.value=chosen;
          paintLife(q('[data-life]'),b.getAttribute('data-stock'));}
      });

      qa('[data-q]',form).forEach(function(b){
        b.addEventListener('click',function(){
          var v=Math.max(parseInt(qty.value||'1',10)+parseInt(b.dataset.q,10),1);
          qty.value=v;});
      });

      form.addEventListener('submit',function(e){
        e.preventDefault();
        if(!chosen){ if(note){note.textContent='PICK A SIZE FIRST';note.classList.add('err');} return; }
        var label=atc.textContent;
        atc.classList.add('busy'); atc.textContent='SENDING…';
        fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
          .then(function(r){ if(!r.ok)return r.json().then(function(j){throw new Error(j.description||'Could not add');});
                             return r.json(); })
          .then(function(){ atc.textContent='RECEIVED ✓';
            return get().then(function(){ open();
              setTimeout(function(){atc.classList.remove('busy');atc.textContent=label;},1400); }); })
          .catch(function(err){
            atc.classList.remove('busy'); atc.textContent=label;
            if(note){note.textContent=(err.message||'COULD NOT ADD').toUpperCase();note.classList.add('err');}
            console.error('TRIANGLE add:',err); });
      });
    });

    get();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
  else boot();
})();
